import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { DescriptionEl } from "./Modal.styles";
import type { ModalDescriptionProps } from "./Modal.types";

const ModalDescriptionComponent = (
  props: ModalDescriptionProps,
): ReactElement => {
  const { children, content, className, style } = props;
  return (
    <DescriptionEl className={cx(className)} style={style}>
      {children ?? content}
    </DescriptionEl>
  );
};

export const ModalDescription = styled(ModalDescriptionComponent)``;
